import { gql } from 'apollo-angular';

// ─── Queries ──────────────────────────────────────────────────────────────────

export const GET_WORKFLOWS = gql`
  query ($tenantId: ID!, $types: [String]) {
    workflows(tenantId: $tenantId, types: $types) {
      id
      tenantId
      name
      type
      status
      silenced
      includedSegmentIds
      triggers
      collectorIds
      nodes {
        nodeId
        type
        parameters
        childrenIds
        __typename
      }
    }
  }
`;

export const GET_SLIM_WORKFLOWS = gql`
  query ($tenantId: ID!) {
    workflows(tenantId: $tenantId) {
      id
      name
      type
      status
    }
  }
`;

export const GET_WORKFLOW = gql`
  query ($id: ID!) {
    workflow(id: $id) {
      id
      name
      type
      status
      silenced
      includedSegmentIds
      triggers
      collectorIds
      bucket {
        start
        finish
      }
      nodes {
        nodeId
        type
        position
        parameters
        childrenIds
        diagram {
          coordinates {
            x
            y
          }
        }
        __typename
      }
    }
  }
`;

export const GET_WORKFLOW_TRIGGERS = gql`
  query ($tenantId: ID!) {
    workflowTriggers(tenantId: $tenantId) {
      id
      name
      available
    }
  }
`;

export const GET_WORKFLOW_PRIORITY_BY_TENANT = gql`
  query ($tenantId: ID!) {
    workflowPriorityByTenant(tenantId: $tenantId) {
      tenantId
      workflowIds
      __typename
    }
  }
`;

export const GET_LINKED_WORKFLOWS = gql`
  query ($id: ID!) {
    linkedWorkflows(id: $id) {
      id
      name
      type
    }
  }
`;

// ─── Mutations ────────────────────────────────────────────────────────────────

export const CREATE_WORKFLOW = gql`
  mutation ($input: CreateWorkflowInput!) {
    createWorkflow(input: $input) {
      id
      tenantId
      name
      type
      status
      silenced
      collectorIds
      triggers
      bucket {
        start
        finish
      }
      includedSegmentIds
    }
  }
`;

export const UPDATE_WORKFLOW = gql`
  mutation ($input: UpdateWorkflowInput!) {
    updateWorkflow(input: $input) {
      id
      name
      status
      silenced
      includedSegmentIds
      bucket {
        start
        finish
      }
      nodes {
        nodeId
        type
        position
        parameters
        diagram {
          coordinates {
            x
            y
          }
        }
        childrenIds
      }
    }
  }
`;

export const PUBLISH_WORKFLOW = gql`
  mutation ($input: PublishWorkflowInput!) {
    publishWorkflow(input: $input) {
      id
      name
      status
      silenced
      nodes {
        nodeId
        type
        parameters
      }
    }
  }
`;

export const PAUSE_WORKFLOW = gql`
  mutation ($input: PauseWorkflowInput!) {
    pauseWorkflow(input: $input) {
      id
      status
    }
  }
`;

export const UNPUBLISH_WORKFLOW = gql`
  mutation ($input: UnPublishWorkflowInput!) {
    unPublishWorkflow(input: $input) {
      id
      name
      status
      silenced
      nodes {
        nodeId
        type
        parameters
      }
    }
  }
`;

export const DELETE_WORKFLOW = gql`
  mutation ($id: ID!) {
    deleteWorkflow(id: $id) {
      id
    }
  }
`;

export const UPDATE_WORKFLOW_PRIORITY = gql`
  mutation ($input: UpdateWorkflowPriorityInput!) {
    updateWorkflowPriority(input: $input) {
      tenantId
      workflowIds
    }
  }
`;
